module.exports = __webpack_public_path__ + "img/EOS.de519635.svg";